// Detects whether the current item is in a shared folder or shared mailbox.
// The existence of getSharedPropertiesAsync is NOT a reliable signal: modern
// Outlook clients expose the method on every item. The documented way to
// detect a shared context is to call it and check the result status:
// https://learn.microsoft.com/office/dev/add-ins/outlook/delegate-access#identify-if-a-folder-or-mailbox-is-shared
export const getSharedProperties = (): Promise<Office.SharedProperties | null> =>
  new Promise((resolve) => {
    const { item } = Office.context.mailbox;

    if (!item || !item.getSharedPropertiesAsync) {
      resolve(null);
      return;
    }

    item.getSharedPropertiesAsync((result) => {
      // A Failed status means the item is not in a shared context
      if (result.status === Office.AsyncResultStatus.Succeeded && result.value) {
        resolve(result.value);
      } else {
        resolve(null);
      }
    });
  });
